import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NewsletterListState, NewsletterListStateModel } from './newsletter-list.state';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { NewsletterItem, NewsletterListSearchCriteria } from '../models/newsletter.model';
import { NewsletterListInitialState, NewsletterListLoad } from './newsletter-list.actions';

@Injectable({ providedIn: 'root' })
export class NewsletterListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<NewsletterListStateModel> = this.store.select(NewsletterListState.getState);
  items$: Observable<NewsletterItem[]> = this.store.select(NewsletterListState.getItems);
  loaded$: Observable<boolean> = this.store.select(NewsletterListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Newsletters)
      .subscribe((searchCriteria: NewsletterListSearchCriteria) => {
        this.store.dispatch(new NewsletterListLoad(searchCriteria));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new NewsletterListInitialState());
  }
}
